import SecureRequest from "../utils/securerequest";

interface UploadAvatarParams {
  userId: number;
  file: File;
  cropParams?: string;
}

interface UploadAvatarResponse {
  success: boolean;
  imageUrl: string;
  userId: number;
}

const compressImage = (file: File, maxWidth: number = 800, quality: number = 0.8): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const img = new Image();
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }
        
        ctx.drawImage(img, 0, 0, width, height);
        
        const compressedBase64 = canvas.toDataURL(file.type, quality);
        const base64String = compressedBase64.split(',')[1];
        resolve(base64String);
      };
      
      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };
      
      img.src = e.target?.result as string;
    };
    
    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };
    
    reader.readAsDataURL(file);
  });
};

export const uploadUserAvatar = async ({ 
  userId, 
  file,
  cropParams
}: UploadAvatarParams): Promise<{ data: UploadAvatarResponse }> => {
  try {
    const base64String = await compressImage(file);
    
    const sr = new SecureRequest();
    const Request = sr.getRequest();
    
    const payload = {
      file: base64String,
      contentType: file.type,
      originalFilename: file.name,
      cropParams,
    };
    
    const response = await Request.post(`/v3/team-members/${userId}/avatar`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};
